import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import { Component } from 'react';

import './UpdateContact.css';
import { check_contact } from '../../utils/it_contacts';
import ContactForm from '../ContactForm/ContactForm';

interface Props {
    contact: any
    onUpdate: (update: any) => void
}
interface State {
    entity?: any
    updating: boolean
}

export default class UpdateContact extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            entity: this.props.contact ? this.props.contact : undefined,
            updating: false
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.contact !== prevProps.contact) {
            this.setState({
                entity: this.props.contact ? this.props.contact : undefined,
                updating: false
            })
        }
    }


    update = async () => {
        try {
            check_contact(this.state.entity);
        }
        catch (e: any) {
            create_toast({ type: e.type === 'warning' ? 'warning' : 'error', message: e.message })
        }

        if (window.confirm(`Are you sure you want to update contact '${this.state.entity.name}' ?`)) {

            this.setState({ updating: true });
            try {
                let { entity } = this.state;
                let { id } = entity;
                delete entity.id;
                let res = await request(`${API_URL}/api/v1/contacts/${id}`, {
                    method: 'put',
                    data: entity,
                })
                this.setState({ entity: res.data.value });
                create_toast({ type: 'success', message: res.data.message })
                this.props.onUpdate?.(res.data.value)
            }
            catch (e: any) {
                axiosErrorHandler(e, {
                    functionName: 'update',
                    requestName: 'update_contact',
                })
                toast_request_error(e);
            }
            finally {
                this.setState({ updating: false });
            }
        }
    }

    render() {
        return (
            <>
                <ContactForm
                    contact={this.state.entity}
                    onChange={(updates: any) => {
                        this.setState({
                            entity: {
                                ...this.state.entity,
                                ...updates
                            }
                        })
                    }}
                />
                <br />
                <br />
                {
                    this.state.updating ?
                        <div className="custom-button disabled inverted alt">
                            <Spinner white height={12} /> UPDATING CONTACT
                        </div>
                        :
                        <div className="custom-button green inverted alt" onClick={this.update}>
                            <i className="fas fa-pen" /> UPDATE CONTACT
                        </div>
                }
            </>
        );
    }
};